/* ══════════════════════════════════════════════════════════════════
   47X · HOME V6.1
   Script EXCLUSIVO del home nuevo · namespace H61.

   CONTRATO DE FLUIDEZ
     · Cero rAF, cero setInterval, cero librerías.
     · Los carruseles son scroll-snap del navegador: aquí solo se
       marca el punto activo, y eso va con IntersectionObserver, no
       con listeners de scroll.
     · Un solo observer para TODAS las fotos de la página.
     · Los listeners van delegados en la raíz: no importa cuántas
       cards haya, siempre son los mismos tres.

   COMPRAR EN 2 TAPS
     Tap 1 la talla, tap 2 AGREGAR. Se manda a /cart/add.js y se avisa
     al tema para que abra su drawer. Nunca se recarga la página.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.H61) return;
  window.H61 = { v: 1 };

  /* Cada sección del home lleva su propio .h61 · Shopify no permite un
     contenedor único que las abarque a todas. Por eso se delega en
     document y se acota comprobando el ancestro .h61: un solo juego de
     listeners para toda la página, sin importar cuántas secciones haya. */
  if (!document.querySelector('.h61')) return;
  var raiz = document;

  var enVuelo = false;

  function dinero(c) {
    return '$' + (Math.abs(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── punto activo del carrusel de cada card ──
     Un observer para toda la página. Se dispara solo cuando una foto
     entra o sale: no hay trabajo por frame ni cálculos en scroll. */
  var visor = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    for (var i = 0; i < ents.length; i++) {
      var e = ents[i];
      if (!e.isIntersecting || e.intersectionRatio < 0.6) continue;
      var tira = e.target.parentNode;
      var card = tira && tira.closest ? tira.closest('[data-h61-card]') : null;
      if (!card) continue;
      var dots = card.querySelector('[data-h61-dots]');
      if (!dots) continue;
      var idx = [].indexOf.call(tira.children, e.target);
      var ps = dots.children;
      for (var k = 0; k < ps.length; k++) ps[k].classList.toggle('is-on', k === idx);
    }
  }, { root: null, threshold: [0.6] }) : null;

  function observaFotos() {
    if (!visor) return;
    var fs = document.querySelectorAll('.h61 .h61__foto');
    for (var i = 0; i < fs.length; i++) {
      if (fs[i].__h61) continue;
      fs[i].__h61 = true;
      visor.observe(fs[i]);
    }
  }

  /* ── avisar al tema para que su bolsa y su drawer se enteren ── */
  function avisa(abrir) {
    try { document.dispatchEvent(new CustomEvent('cart47:added')); } catch (e) {}
    if (abrir) { try { document.dispatchEvent(new CustomEvent('cart47:open')); } catch (e) {} }
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var b = document.querySelector('.hdr47__cart-count');
        if (b) b.textContent = String(j.item_count);
        var st = document.querySelector('[data-h61-sticky]');
        var stn = document.querySelector('[data-h61-sticky-n]');
        if (stn) stn.textContent = j.item_count + (j.item_count === 1 ? ' pieza · ' : ' piezas · ') + dinero(j.total_price);
        if (st && j.item_count > 0) st.classList.add('is-on');
      })
      .catch(function () {});
  }

  function di(card, msg) {
    var a = card.querySelector('[data-h61-aviso]');
    if (a) a.textContent = msg || '';
  }

  /* ── DOS TAPS, CARD LIMPIA ──
     La card muestra solo foto, nombre, precio y AGREGAR. El primer tap
     despliega las tallas; el segundo, sobre una talla, ya manda al
     carrito. Si el producto tiene una sola variante, el primer tap
     compra directo. Solo una card puede estar abierta a la vez, así la
     home no se alarga ni brinca.
     Todo delegado en document y acotado a .h61: un solo juego de
     listeners para toda la página. */
  /* ── mapa de variantes ──
     Se lee del JSON inerte de la card la primera vez que hace falta y
     se guarda ahí mismo: no se vuelve a procesar. */
  function variantes(c) {
    if (c.__vars) return c.__vars;
    var s = c.querySelector('[data-h61-vars]');
    try { c.__vars = s ? JSON.parse(s.textContent) : []; } catch (e) { c.__vars = []; }
    return c.__vars;
  }
  function buscaVariante(c) {
    var sels = c.querySelectorAll('[data-h61-sel]');
    if (!sels.length) return null;
    var sel = [];
    for (var i = 0; i < sels.length; i++) sel.push(sels[i].value);
    var vs = variantes(c);
    for (var k = 0; k < vs.length; k++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (vs[k].o[j] !== sel[j]) { ok = false; break; } }
      if (ok) return vs[k];
    }
    return null;
  }
  function refrescaCard(c) {
    var v = buscaVariante(c);
    var btn = c.querySelector('[data-h61-add]');
    if (!btn) return;
    if (!btn.dataset.h61Txt) btn.dataset.h61Txt = btn.textContent;
    if (v && v.a) {
      c.setAttribute('data-h61-variante', v.id);
      btn.disabled = false;
      btn.textContent = btn.dataset.h61Txt;
      di(c, '');
    } else {
      c.removeAttribute('data-h61-variante');
      btn.disabled = true;
      btn.textContent = v ? 'Agotada' : 'No disponible';
    }
  }
  /* Deja cada card en su primera combinación comprable. Se hace una
     vez, al arrancar, y sin tocar el layout: los desplegables ya
     ocupan su espacio desde el HTML. */
  function preseleccionaTodas() {
    var cards = document.querySelectorAll('.h61 [data-h61-card]');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.__pre) continue;
      var sels = c.querySelectorAll('[data-h61-sel]');
      if (!sels.length) continue;
      c.__pre = true;
      var vs = variantes(c);
      for (var k = 0; k < vs.length; k++) {
        if (!vs[k].a) continue;
        for (var j = 0; j < sels.length; j++) sels[j].value = vs[k].o[j];
        break;
      }
      refrescaCard(c);
    }
  }

  function compra(c, variante, add) {
    if (enVuelo || !add) return;
    enVuelo = true;
    if (!add.dataset.h61Txt) add.dataset.h61Txt = add.textContent;
    var prev = add.dataset.h61Txt;
    add.textContent = 'AGREGANDO…';
    add.disabled = true;
    di(c, '');

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'cart'); });
        return r.json();
      })
      .then(function () {
        add.textContent = 'AGREGADA ✓';
        avisa(true);
        setTimeout(function () { add.textContent = prev; add.disabled = false; }, 1400);
      })
      .catch(function (err) {
        di(c, String(err.message || '').slice(0, 70) || 'No se pudo agregar');
        add.textContent = prev; add.disabled = false;
      })
      .then(function () { enVuelo = false; });
  }

  /* cambiar talla o color recalcula la variante al vuelo */
  document.addEventListener('change', function (ev) {
    var s = ev.target;
    if (!s.closest || !s.closest('.h61') || !s.matches('[data-h61-sel]')) return;
    refrescaCard(s.closest('[data-h61-card]'));
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t.closest || !t.closest('.h61')) return;
    var add = t.closest('[data-h61-add]');
    if (!add || add.disabled) return;
    var c = add.closest('[data-h61-card]');
    if (!c) return;
    var v = c.getAttribute('data-h61-variante') || add.getAttribute('data-h61-variante');
    if (!v) { di(c, 'Elige talla y color'); return; }
    compra(c, v, add);
  });

  /* ── switcher de pestañas ──
     Solo alterna el atributo hidden de cada panel. Nada de medir,
     animar ni reconstruir: por eso no puede trabar el scroll. */
  function aplicaTab(sec, cual) {
    var paneles = sec.querySelectorAll('[data-h61-panel]');
    for (var i = 0; i < paneles.length; i++) {
      paneles[i].hidden = paneles[i].getAttribute('data-h61-panel') !== cual;
    }
    var bts = sec.querySelectorAll('[data-h61-ir]');
    for (var k = 0; k < bts.length; k++) {
      bts[k].setAttribute('aria-selected', bts[k].getAttribute('data-h61-ir') === cual ? 'true' : 'false');
    }
    observaFotos();
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var bt = t.closest ? t.closest('[data-h61-ir]') : null;
    if (!bt) return;
    var sec = bt.closest('section');
    if (sec) aplicaTab(sec, bt.getAttribute('data-h61-ir'));
  });
  /* estado inicial: la primera pestaña con contenido */
  var tabsIni = document.querySelectorAll('[data-h61-tabs]');
  for (var ti = 0; ti < tabsIni.length; ti++) {
    var sec0 = tabsIni[ti].closest('section');
    var b0 = tabsIni[ti].querySelector('[data-h61-ir]');
    if (sec0 && b0) aplicaTab(sec0, b0.getAttribute('data-h61-ir'));
  }

  observaFotos();
  preseleccionaTodas();
  avisa(false);
  /* El editor re-inyecta secciones: se vuelven a observar las fotos
     nuevas, sin duplicar nada porque cada una lleva su marca. */
  document.addEventListener('shopify:section:load', function () { observaFotos(); preseleccionaTodas(); });
})();
